<template>
    <div>
        <!-- <a href="http://fun.gxnews.com.cn/zg/"
           v-if="isShow"
           class="download">
            <img src="../assets/images/download.png">
        </a> -->
        <a href="https://fun.gxnews.com.cn/zg/"
           v-if="isShow"
           class="download">
            <div class="aimgopen"><img style="padding-left:10px;padding-top:8px;height:50px;"
                     src="../assets/images/zg_logo.png"></div>
            <div class="aimgopen"><img style="padding-left:12px;padding-top:8px;height:50px;"
                     src="../assets/images/zhuangguan.png"></div>
            <div class="bimgopen"><img style="padding-right:15px;padding-top:16px;height:38px;width:100px;"
                     src="../assets/images/open.png"></div>
        </a>
    </div>
</template>

<script>
export default {
    name: "Download",
    data () {
        return {
            isShow: true
        }
    },
    mounted () {
        this.$bus.$on('hideDownload', (msg) => {
            this.isShow = !msg
        })

        if (window.navigator.userAgent.indexOf('ZgApp') >= 0 || !this.isPhone()) {
            this.isShow = false
        }
    },
    methods: {
        isPhone () {
            let mobile = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
            return mobile != null
        }
    }
}
</script>

<style scoped>
</style>
